import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeColStyles } from './styles';
import { context as GutterContext, gutterStyle } from './useGutter';
export default function ($props, $blocks, $__proto__) {
  var _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    _children = _this$get.children,
    span = _this$get.span,
    style = _this$get.style,
    offset = _this$get.offset,
    push = _this$get.push,
    pull = _this$get.pull,
    order = _this$get.order;
  var k = this.config.k;
  return _$cc(GutterContext.Consumer, {
    'children': function children(gutter) {
      var _extends2, _$cn2;
      var classNameObj = _extends((_extends2 = {}, _extends2[k + "-col"] = true, _extends2[k + "-" + span] = span, _extends2[k + "-offset-" + offset] = offset, _extends2[k + "-pull-" + pull] = pull, _extends2[k + "-push-" + push] = push, _extends2[k + "-order-" + order] = order, _extends2[className] = className && !gutter, _extends2[makeColStyles(k)] = true, _extends2), _this.breakpoints.getBreakpointsClassName(k));
      var newStyle = gutter ? gutterStyle(gutter, style, 'padding') : style;
      return _$cv('div', _extends({
        'className': _$cn(classNameObj)
      }, getRestProps(_this), {
        'style': newStyle
      }), gutter ? _$ce(2, 'div', _children, 0, _$cn((_$cn2 = {}, _$cn2[k + "-col-wrapper"] = true, _$cn2[className] = className, _$cn2))) : _children);
    }
  });
}
;